/**
 * @generated SignedSource<<f1ab932ec7e253e4a50359f880727edb>>
 * @relayHash ec913333acbf6a9e52d09fa8647539fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 31587e898d824eda14df2a81ea9181e00c9637fed7de35436c8ef422142206b0

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraNavigationItemTypeKey = "APP" | "APPROVALS" | "APPS" | "ARCHIVED_ISSUES" | "ATTACHMENTS" | "BACKLOG" | "BOARD" | "CALENDAR" | "CAPACITY" | "CODE" | "COMPONENTS" | "CUSTOMER_SUPPORT" | "DEPENDENCIES" | "DEPLOYMENTS" | "DEVELOPMENT" | "FORMS" | "GET_STARTED" | "GOALS" | "INBOX" | "INCIDENTS" | "ISSUES" | "LIST" | "ON_CALL" | "PAGES" | "PLAN_CALENDAR" | "PLAN_DEPENDENCIES" | "PLAN_PROGRAM" | "PLAN_RELEASES" | "PLAN_SUMMARY" | "PLAN_TEAMS" | "PLAN_TIMELINE" | "PROGRAM" | "QUEUE" | "RELEASES" | "REPORTS" | "REQUESTS" | "SECURITY" | "SHORTCUTS" | "STAFFING" | "SUMMARY" | "TEAMS" | "TIMELINE" | "%future added value";
export type JiraContainerNavigationQueryInput = {
  projectKeyQuery?: JiraContainerNavigationByProjectKeyQueryInput | null | undefined;
  scopeId?: string | null | undefined;
};
export type JiraContainerNavigationByProjectKeyQueryInput = {
  cloudId: string;
  projectKey: string;
};
export type AddTabContentQuery$variables = {
  containerNavigationInput: JiraContainerNavigationQueryInput;
  first: number;
};
export type AddTabContentQuery$data = {
  readonly jira: {
    readonly containerNavigation: {
      readonly __typename: "JiraContainerNavigation";
      readonly addableNavigationItemTypes: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly appId?: string | null | undefined;
            readonly id: string;
            readonly typeKey: JiraNavigationItemTypeKey;
            readonly " $fragmentSpreads": FragmentRefs<"AddTabDetails_item" | "AppItem" | "ViewItem_item">;
          };
        } | null | undefined>;
        readonly errors: ReadonlyArray<{
          readonly extensions: ReadonlyArray<{
            readonly statusCode: number | null | undefined;
          }> | null | undefined;
          readonly message: string | null | undefined;
        }> | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly scopeId: string;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type AddTabContentQuery = {
  response: AddTabContentQuery$data;
  variables: AddTabContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerNavigationInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "containerNavigationInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "scopeId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v7 = {
  "kind": "ScalarField",
  "name": "appId"
},
v8 = {
  "kind": "ScalarField",
  "name": "message"
},
v9 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v10 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v9/*: any*/)
  ]
},
v11 = [
  (v8/*: any*/),
  {
    "kind": "LinkedField",
    "name": "extensions",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      (v9/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AddTabContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "kind": "LinkedField",
                "name": "containerNavigation",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "RequiredField",
                        "field": (v3/*: any*/),
                        "action": "THROW",
                        "path": "jira.containerNavigation.id"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v4/*: any*/),
                        "action": "THROW",
                        "path": "jira.containerNavigation.scopeId"
                      },
                      {
                        "args": (v5/*: any*/),
                        "concreteType": "JiraNavigationItemTypeConnection",
                        "kind": "LinkedField",
                        "name": "addableNavigationItemTypes",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "concreteType": "JiraNavigationItemTypeEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "RequiredField",
                                  "field": {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "RequiredField",
                                        "field": (v3/*: any*/),
                                        "action": "THROW",
                                        "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node.id"
                                      },
                                      {
                                        "kind": "RequiredField",
                                        "field": (v6/*: any*/),
                                        "action": "THROW",
                                        "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node.typeKey"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v7/*: any*/)
                                        ],
                                        "type": "JiraAppNavigationItemType"
                                      },
                                      {
                                        "kind": "FragmentSpread",
                                        "name": "ViewItem_item"
                                      },
                                      {
                                        "kind": "FragmentSpread",
                                        "name": "AppItem"
                                      },
                                      {
                                        "kind": "FragmentSpread",
                                        "name": "AddTabDetails_item"
                                      }
                                    ]
                                  },
                                  "action": "THROW",
                                  "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node"
                                }
                              ]
                            },
                            "action": "THROW",
                            "path": "jira.containerNavigation.addableNavigationItemTypes.edges"
                          },
                          {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "JiraContainerNavigation"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/)
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.containerNavigation"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddTabContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "containerNavigation",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "args": (v5/*: any*/),
                    "concreteType": "JiraNavigationItemTypeConnection",
                    "kind": "LinkedField",
                    "name": "addableNavigationItemTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraNavigationItemTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isJiraNavigationItemType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "label"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "iconUrl"
                                  }
                                ],
                                "type": "JiraAppNavigationItemType"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": (v11/*: any*/)
                      }
                    ]
                  }
                ],
                "type": "JiraContainerNavigation"
              },
              {
                "kind": "InlineFragment",
                "selections": (v11/*: any*/),
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "31587e898d824eda14df2a81ea9181e00c9637fed7de35436c8ef422142206b0",
    "metadata": {},
    "name": "AddTabContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "71ecbefb47764ebf91a81a758124f6ec";

export default node;
